import InputField from "components/fields/InputField";
import { Link } from "react-router-dom";

const Login = () => {
  return (
    <div className="mt-12 mb-6 flex items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      {/* Sign in section */}
      <div className="px-5 md:px-[78px] py-[39px] w-full md:w-auto md:mx-auto box overflow-hidden bg-white dark:bg-darkPrimary flex-col items-center">
        <h4 className="text-center mb-2.5 text-h1 text-navy-700 dark:text-white">
          Sign In
        </h4>
        <p className="text-center mb-6 ml-1 text-medium text-gray-700">
          Hi there, welcome back to BBA
        </p>
        {/* Email */}
        <InputField
          variant="auth"
          extra="mb-5 md:min-w-[350px]"
          label="Email"
          placeholder="Email"
          id="email"
          type="text"
          required={true}
        />

        <div className="relative">
          {/* Password */}
          <InputField
            variant="auth"
            extra="mb-5 md:min-w-[350px]"
            label="Password"
            placeholder="Enter your password"
            id="password"
            type="password"
            required={true}
            ispassword={true}
          />
          <span className="absolute right-1 top-0 text-gray-800">Forgot your password?</span>
        </div>
        <button className="linear w-full btn">
          Sign In
        </button>
        <div className="mt-4 text-center">
          <span className="dark:text-gray-700">
          Don’t have an account?
          </span>
          <Link
            to="/register"
            className="ml-1 text-green-900 hover:text-brand-600"
          >
            Sign Up
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Login;